import React from 'react';

const Input = ({
  register,
  name,
  label,
  errors,
  placeholder,
  id,
  class_name = 'form-control',
  type = 'text',
  required,
}) => {
  return (
    <>
      <div className="form-input-group">
        {!!label && (
          <label>
            {label}
            {!!required && <span className="link-red">*</span>}
          </label>
        )}
        <input
          type={type}
          id={id}
          placeholder={placeholder}
          name={name}
          ref={register}
          className={`${class_name} ${(!!errors && 'input-valid') || ''}`}
        />
        {errors && (
          <span className="error">
            <small>{errors.message}</small>
          </span>
        )}
      </div>
    </>
  );
};

export default Input;
